import { LngLatBoundsLike, ViewState } from 'react-map-gl/dist/esm/types';
import { makeAutoObservable } from 'mobx';
import { I3Model } from './components/model';
import { apiServiceV2 } from '../../services/apiService';
import { transformModelData } from '../../helpers/utils';

class MapStore {
  maxBounds: LngLatBoundsLike = [
    [-179.99, -85],
    [179.99, 85],
  ];

  initialViewState: Partial<ViewState> = {
    latitude: 40.181824240474036,
    longitude: 44.517631530761726,
    zoom: 13,
    pitch: 0,
  };

  bounds: any;

  mapRef: any;

  mapMarkers: any = [];

  models: I3Model[] = [];

  defaultBounds: Array<any[]> | any[] = [
    [
      [44.8787807824842, 41.33695558782361],
      [45.31602506590335, 38.74574583875656],
    ],
  ];

  constructor() {
    makeAutoObservable(this);
  }

  getModels = async () => {
    try {
      if (this.models.length) return;
      const models = await apiServiceV2.getMapModels();
      const data: I3Model[] = transformModelData(models.data.result);
      this.models = data;
    } catch (error) {
      console.log(error);
    }
  };

  getMarkersList = async () => {
    const res = await apiServiceV2.getLocations();
    if (!res.error) {
      this.createMarkersStructure(res.data);
    }
  };

  setModelParams = async (data: I3Model) => {
    this.models = this.models.map((model) => {
      if (model.public_id === data.public_id) {
        model = data;
      }
      return model;
    });
  };

  setBounds = (bounds: any) => {
    bounds = bounds.reduce((acc: any, item: any) => {
      acc = [...acc, ...item];
      return acc;
    }, []);

    if (bounds.length > 0) {
      const lngs = bounds.map((bound: any) => bound[1]);
      const lats = bounds.map((bound: any) => bound[0]);
      const minLng = Math.min(...lngs);
      const maxLng = Math.max(...lngs);
      const minLat = Math.min(...lats);
      const maxLat = Math.max(...lats);
      this.bounds = [
        [minLat, minLng],
        [maxLat, maxLng],
      ];
    }
  };

  searchInMap = (bounds: any) => {
    if (bounds.length > 0) {
      const lngs = bounds.map((bound: any) => bound[1]);
      const lats = bounds.map((bound: any) => bound[0]);
      const minLng = Math.min(...lngs);
      const maxLng = Math.max(...lngs);
      const minLat = Math.min(...lats);
      const maxLat = Math.max(...lats);
      this.bounds = [
        [minLng, minLat],
        [maxLng, maxLat],
      ];
    }
  };

  createMarkersStructure = (markers: any) => {
    markers.forEach((marker: any) => {
      this.mapMarkers.push({
        latitude: marker.latitude,
        longitude: marker.longitude,
        popupInfo: marker.room,
        type: 'open',
      });
    });
    this.mapMarkers = [...this.mapMarkers];
  };

  setMarkers = (markers: any) => {
    this.mapMarkers = markers;
  };

  navigationInMap = (coordinates: any | any[] = []) => {
    if (!Array.isArray(coordinates)) return;
    let currnetCoordinates: any[] = [];
    if (!coordinates.length) currnetCoordinates = this.defaultBounds as any[];
    else if (!coordinates.some(Array.isArray))
      currnetCoordinates = [coordinates as any];
    else currnetCoordinates = coordinates as any[];

    this.setBounds(currnetCoordinates);
  };

  removeState() {}
}
export const mapStore = new MapStore();
